export let unarchiveTypeIds = {
	temporary: 1,
	permanent: 2,
};

export let unarchiveTypeLabels = {
	1: 'i18n.temporarily',
	2: 'i18n.permanently',
};

export let unarchiveTypes = _.invert(unarchiveTypeIds);

export default {
	unarchiveTypeIds: unarchiveTypeIds,
	unarchiveTypeLabels: unarchiveTypeLabels,
	unarchiveTypes: unarchiveTypes,
};
